/** Flush mounted debounced editors before actions that share their server content. */
const drafts = new Map<symbol, { flush: () => void; dirty: () => boolean }>();
const listeners = new Set<() => void>();
export const notifyDrafts = () => listeners.forEach((listener) => listener());
export function registerProposalDraft(draft: {
  flush: () => void;
  dirty: () => boolean;
}) {
  const key = Symbol();
  drafts.set(key, draft);
  return () => {
    drafts.delete(key);
    notifyDrafts();
  };
}
export const subscribeDrafts = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
export const pendingDrafts = () =>
  [...drafts.values()].filter((draft) => draft.dirty()).length;
export const flushDrafts = () => drafts.forEach((draft) => draft.flush());
